
var axtable_details_click = function(event){
  var id = $(this).closest('.trow').data('id');
  if (typeof(id) == 'undefined'){
    show_alert(_error_label, err_operation_failed);
    return false;
  }
  tabs_goto(event.data.detailsPath + '/' + id);
  event.stopPropagation();
};

var get_axtable_content_container = function(axtable_element) {
  var container_class = "axtable-content-container";
  var container_selector = "." + container_class;
  var custom_scroll_selector = ".mCSB_container";

  if (!axtable_element.has(container_selector).length) {
    axtable_element.append($("<tbody class='" + container_class + "'></tbody>"));
  }

  var container = axtable_element.find(container_selector);

  if (container.has(custom_scroll_selector).length) {
    container = container.find(custom_scroll_selector);
  }

  return container;
};

/*
 * General purpose function for processing the a cell click from columns in the
 * axTable that are showing data for a secondary entity. The function expects that
 * the id for the secondary entity can be found on the row.
 */
var axTableSecondaryEntityClick = function(event, id_ref, tab_sel, tab_url) {
  var id = $(event.target).closest('.trow').data(id_ref);
  if (typeof(id) == 'undefined') {
    // FIXME - BETTER MESSAGE SHOULD BE DISPLAYED
    show_alert(_error_label, err_operation_failed);
    return false;
  }

  var idx = $(tab_sel).index();
  $('#tabs').tabs('option', 'active', idx);
  tabs_goto(tab_url + id);
  event.stopPropagation();
};

(function($){
  $.widget("ax.axTableIndexCard", {
    iconCssClass  : 'axTableIndexCard toggle-icon',
    isActive      : false,
    isInitialized : false,
    dataLocation  : false,
    isDirty       : false,
    searchData    : false,
    fetchTitle    : false,
    fetchXHR      : false,
    options : {
      columns             : 2,
      fetchOffset         : 0,
      sortCol             : 0,
      sortDir             : 'asc',
      searchData          : false,
      dataLocation        : false,
      initialFetchAmount  : false,
      fetchAmount         : 20,
      template            : false,
      emptySearchHandler  : { template: 'axtable-empty_search', data: {} },
      noDataHandler       : { template: 'axtable-empty', data: {} }
    },

    _create : function(){
      var settings = this.options;
      if (!settings.initialFetchAmount) {
        settings.initialFetchAmount = settings.fetchAmount;
      }

      // Check to see if the template we need is present in our cache
      if (!window.cachedAxTemplates[settings.template]) {
        $.ajax({
          url: "/template/" + settings.template,
          success: function(template){
            // Save in cache for next time.
            window.cachedAxTemplates[settings.template] = template;
          },
          async: false
        });
      }
    },

    clear : function(){
      var self = this;
      this.element.find(".list-card").remove();
      this.element.siblings(".list-empty").remove();
      this.element.siblings(".tabempty").remove();
      this.element.find(".clear_both").remove();
      self.isDirty = false;
    },

    addIndexCard : function(data, columns, template){
      /*
       * For each row of data, we need to do the following
       * - clone the template
       * - iterate the data values
       * -- for each "column" see if we can find it in the clone, and stick value into template
       * - make the clone visible
       * - add clone to the container
       */

      var columnindex = 0, colName, rowData = {};
      // Set the view data on the card
      $.each(data.rowData, function(index, dataval){
        colName = columns[columnindex].name;
        rowData[colName] = dataval;

        columnindex++;
      });

      var card = Handlebars.compile(template)(rowData);

      card = $(card);

      card.removeClass('template').addClass('left');

      // Persist data that might be needed later
      for (var attr in data.rowAttr) {
        card.attr('data-' + attr, data.rowAttr[attr]);
      }

      return card;
    },

    fetchdata : function(deferred){
      var self = this, settings = self.options,
        getData = { "inc_title" : self.fetchTitle },
        fetchnum = settings.fetchAmount;

      // do we have a server-side location?
      if (!settings.dataLocation) {
        return;
      }

      // Are we already processing a request?
      if (self.fetchXHR){
        self.fetchXHR.abort();
      }

      if (settings.fetchOffset == 0) {
        fetchnum = settings.initialFetchAmount;
      }

      getData.offset = settings.fetchOffset;
      getData.amount = fetchnum;
      getData.sort_col = settings.sortCol;
      getData.sort_dir = settings.sortDir;
      // FIXME - REMOVE ME WHEN IN PRODUCTION
      getData.inc_headers = true;

      // TODO - REFACTOR AND MOVE INTO SUPERCLASS THAT BOTH VIEWS INHERIT FROM
      if (self.searchData) {
        for (var prop in self.searchData) {
          var curVal = self.searchData[prop];
          if (((typeof(curVal) == 'string') && (curVal !== '')) || (Array.isArray(curVal) && (curVal.length > 0))) {
            getData.search = self.searchData;
            break;
          }
        }
      }

      self.fetchXHR = $.ajax({
        url: settings.dataLocation,
        dataType: 'json',
        data: getData,
        type: 'POST',
        error: function(jqXHR, textStatus, errorThrown){ self.fetchXHR = false; },
        success: function(data, jqXHR, textStatus){
          // We have the data, display it.
          self.fetchXHR = false;

          // This is our first time fetching data, let's render the columns.
          if (getData.offset == 0) {
            self.clear();
          }

          // Let's render the data.
          var cardindex = 0;
          $.each(data.data, function(){
            card = self.addIndexCard(this, data.columns, window.cachedAxTemplates[settings.template]);

            card.show();
            self.element.append(card);

            cardindex++;
          });

          settings.fetchOffset += fetchnum;

          // FIXME - EVENT FOR DATA RETRIEVED - USE TO BUILD TITLE OR PREFORM DATA PROCESSING. INDICATOR FOR END OF DATA REACHED!
          if (typeof(deferred) == 'object') {
            deferred.resolve(getData, data);
          }
        }
      });
    },

    addNoDataPane : function(config) {
      var self = this, axTbl = this.options.axtable,
        template = config.template, datasource = config.data;

      if (typeof datasource === 'function') {
        datasource = datasource();
      }

      // Check to see if the template we need is present in our cache
      if (!window.cachedAxTemplates[template]) {
        // Miss
        if (!self.fetchingNoDataPane) {
          //Set semaphor to keep from refetching and re-appending same pane. Seems ugly. Would like a better way.
          self.fetchingNoDataPane = true;
          $.get("/template/" + template, function(tmplt){
            // Save in cache for next time.
            window.cachedAxTemplates[template] = tmplt;
            self.fetchingNoDataPane = false;
            self.addNoDataPane(config);
          });
        }
        return;
      } else {
        template = window.cachedAxTemplates[template];
      }

      // track the the summary pane event
      gtag('event', 'axTableIndexCard', {
        'event_category': 'NoDataPane',
        'event_label': 'table: ' + (typeof(axTbl) != 'undefined' ? axTbl.element.attr('id') : 'unspecified_table') + ', datasource: ' + datasource
      });

      var html = Handlebars.compile(template)(datasource);

      if (config.noContainer) {
        this.element.append(html);
      } else {
        var pane = $("<div>").addClass('list-empty list-no-data')
						.html(html);
        this.element.after(pane);
      }
    },

    addEmptyFilterPane : function(config) {
      var self = this, axTbl = this.options.axtable,
        template = config.template, datasource = config.data;

      // Check to see if the template we need is present in our cache
      if (!window.cachedAxTemplates[template]) {
        // Miss
        if (!self.fetchingEmptyFilterPane) {
          // Set semaphor to keep from refetching and re-appending same pane.
          // Seems ugly. Would like a better way.
          self.fetchingEmptyFilterPane = true;
          $.get("/template/" + template, function(tmplt) {
            // Save in cache for next time.
            window.cachedAxTemplates[template] = tmplt;
            self.fetchingEmptyFilterPane = false;
            self.addEmptyFilterPane(config);
          });
        }
        return;
      } else {
        template = window.cachedAxTemplates[template];
      }

      // track the the summary pane event
      gtag('event', 'axTableIndexCard', {
        'event_category': 'EmptyFilterPane',
        'event_label': 'table: ' + (typeof(axTbl) != 'undefined' ? axTbl.element.attr('id') : 'unspecified_table') + ', datasource: ' + datasource
      });

      var html = Handlebars.compile(template)(datasource);
      var pane = $("<div>").addClass('list-empty')
					.html(html);

      pane.find('.clear-filter').on('click', function() {
        gtag('event', 'axTableIndexCard', {
          'event_category': 'ResetFilter',
          'event_label': 'table: ' + (typeof(axTbl) != 'undefined' ? axTbl.element.attr('id') : 'unspecified_table') + ', datasource: ' + datasource
        });
        axTbl._trigger('resetfilter');
      });

      this.element.after(pane);
    }
  });

  $.widget("ax.axTableList", {
    iconCssClass  : 'axTableList toggle-icon',
    isActive      : false,
    isInitialized : false,
    dataLocation  : false,
    isDirty       : false,
    searchData    : false,
    fetchTitle    : false,
    fetchXHR      : false,
    cache         : { },
    options : {
      fetchOffset         : 0,
      sortCol             : -1,
      sortDir             : 'asc',
      sorting             : true,
      clientSideSorting   : false,
      searchData          : false,
      closePopoutOnChose  : true,
      popoutTemplate      : false,
      dataLocation        : false,
      dataProvider        : false,
      initialFetchAmount  : false,
      preventiveSearchData: false,
      fetchAmount         : 20,
      fetchOnScroll       : false,
      actionCol           : false,
      actionClickHandler  : false,   // The override handler for the actionCol click handler that shows the popout menu for each row
      mutableColumnSet    : false,    // Column set can be changed depending on filter criteria
      //Deprecated!!
      //fillHeaderWidth     : false,
      emptySearchHandler  : { template: 'axtable-empty_search', data: {} },
      noDataHandler       : { template: 'axtable-empty', data: {} },
      onFetchHandler      : false,   // function to be called when data fetched
      summaryHandler      : false,   // The data for displaying a summary pane, the summary ajax request path, and template name
			isSummaryCanBeOpened  : function (row) { return true; }, // function for summary pane enabled check
      preventDataRefresh  : function() { return false; }, // function is used to prevent refresh table data
      detailsHandler      : false,   // The override handler for the details page navigation
      detailsPath         : false,   // The Path to the details page when someone clicks on the details column value
      multiSelect         : false,   // Turns on the multiSelect checkbox column
      restoreSummaryPanes : true,    // if set to False - summary panes won't be restored when data refreshed
      rowContentCollector : null,    // summary pane info can stale with time and become different from regularly updated row content,
                                     // so we need to check necessity to update summary pane on every row update using this function
                                     // for comparing old row content with new one
      handler             : false
    },

    _assign_header_click : function(row){
      var self = this, settings = self.options;
      $(row).find(".heading").not(".selectcell,.action_cell").click(function(e){
        gtag('event', 'axTableList', {
          'event_category': 'Sort',
          'event_label': 'table: ' + (typeof(settings.axtable) != 'undefined' ? settings.axtable.element.attr('id') : 'unspecified_table') + ', datasource: ' + settings.dataLocation
        });

        var thisIndex = $(this).index(); //index relative to siblings!!
        // if multi-select column exists, Index must be decremented because select column offsets index
        if(settings.multiSelect) {
          thisIndex--;
        }
        if( settings.sortCol == thisIndex ){
          settings.sortDir = (settings.sortDir == 'asc') ? 'desc' : 'asc';
        } else {
          settings.sortDir = 'asc';
        }
        settings.sortCol = thisIndex;
        if (settings.clientSideSorting) {
          self._sort();
        } else {
          settings.axtable.reset();
        }

        e.stopPropagation();
      });

      if (!settings.readonly) {
        $(row).find(".multiselect").on('click', {self: self}, settings.multiSelectClickHandler);

        // LookHere: checking all boxes

        $(row).find(".selectcell").click(function(e){
          gtag('event', 'axTableList', {
            'event_category': 'Select All - Header',
            'event_label': 'table: ' + (typeof(settings.axtable) != 'undefined' ? settings.axtable.element.attr('id') : 'unspecified_table') + ', datasource: ' + settings.dataLocation
          });

          var current_state = $(row).data('all-selected');

          var checkboxes = $(row).parent().find('input:checkbox:not(:disabled)');
          var checked = checkboxes.filter(':checked');

          var new_state;
          if (checked.length === 0) {
            new_state = true;
          } else {
          	new_state = checkboxes.length === checked.length ? false : !current_state;
					}

          $(checkboxes).each(function(index){
            $(this).prop('checked', new_state);
            $(this).change();
          });

          $(row).data('all-selected', new_state);

          self._persistMultiSelect();
        });
      }
    },

    _create : function(){
      var self = this, settings = self.options;

      self.cache = {};

      if (!settings.popoutTemplate) {
        console.log("axTable: Please define a popoutTemplate.");
      }

      if (!settings.initialFetchAmount) {
        settings.initialFetchAmount = settings.fetchAmount;
      }

      if (!settings.actionClickHandler){
        settings.actionClickHandler = self.actionCellClick;
      }
      else {
        settings.actionClickHandler = window[settings.actionClickHandler];
      }

      if (!settings.multiSelectClickHandler){
        settings.multiSelectClickHandler = self.multiselectCellClick;
      }
      else {
        settings.multiSelectClickHandler = window[settings.multiSelectClickHandler];
      }


      // FIXME - THIS CODE WON'T WORK ANY LONGER BECAUSE THE SEMANTICS THAT WERE MERGED IN CHANGED.
      handler = this.options.handler || self.notify;
      $(document).on('modify.axTableList', self, handler);

      $("html").click(function(event){
        self.killpopout();
      });
    },

    _sort : function() {
      var self = this, settings = self.options;
      var sortCol = settings.multiSelect ? settings.sortCol + 1 : settings.sortCol;
      var tsort_args = ['td:eq(' + sortCol + ')', { order: settings.sortDir }]; // default sort params
      var header_col = $(self.element).find('.trow:eq(0) tr:eq(' + settings.sortCol + ')').not(".selectcell,.action_cell");
      if( header_col.data('sortby')) {
        tsort_args = ['', { order: settings.sortDir, data: header_col.data('sortby') }];
      }

      $(self.element).find('.list-summary').remove();
      var oThis = $(self.element).find('.trow:gt(0)');
      oThis.tsort.apply(oThis, tsort_args);
      self._restoreSummaryPane();
      self._restoreActivePopout();

      // set sorting arrow
      var heading = self.element.find('.trow .heading').not(".selectcell,.action_cell");
      $('.ax-interaction', heading).removeClass('arrow-asc arrow-desc');
      heading.eq( settings.sortCol ).find('.ax-interaction').addClass('arrow-' + settings.sortDir);
    },

    /*
     * This doesn't really do a complete reset. The search and columns are retained.
     */
    reset : function(){
      this.options.fetchOffset = 0;
      // FIXME - LOGIC HERE SUSPECT
      this.fetchTitle = true;
      this.fetchdata();
    },

    search : function(val){
      if (val) {
        this.searchData = val;
      }
      this.options.fetchOffset = 0;
      this.clear();
      this.fetchdata();
    },

    selected : function(){
      var curval, vals = new Array();

      this.element.find('.selectcell :checked').each(function(index){
        curval = $(this).closest('.trow').data('id');

        // Check to see that we have real data
        if ((typeof(curval) != 'undefined') && curval) {
          vals.push(curval);
        }
      });

      return vals;
    },

    killpopout : function(){
			this.element.find(".popout").remove();
      this.element.find(".trow.activerow").removeClass("activerow");
      if(this.cache){
        this.cache.activePopoutId = null;
      }
    },

    is_popout_active: function() {
      return this.element.find(".popout:visible").length;
    },

    manual_assign_rows_click : function(){
      var current_tab = $(".ui-tabs-panel:visible");

      current_tab.find(".devicelist .trow.nonheader").each(function(){
        current_tab.find(".devicelist").data('ax-axTable').activeView.assign_row_click($(this));
      });
    },

    addNoDataPane : function(config, params){
      var self = this, axTbl = this.options.axtable,
        template = config.template, datasource = config.data;

      if (typeof datasource === 'function') {
        datasource = datasource();
      }

      if (params !== undefined) {
        Object.assign(datasource, params)
      }

      if (config.hideHeader) {
        this.element.find('.trow:first').hide();
      }

      // Check to see if the template we need is present in our cache
      if (!window.cachedAxTemplates[template]) {
        // Miss
        if (!self.fetchingNoDataPane) {
          // Set semaphor to keep from refetching and re-appending same pane. Seems ugly. Would like a better way.
          self.fetchingNoDataPane = true;
          $.get("/template/" + template, function(tmplt){
            // Save in cache for next time.
            window.cachedAxTemplates[template] = tmplt;
            self.fetchingNoDataPane = false;
            self.addNoDataPane(config);
          });
        }
        return;
      } else {
        template = window.cachedAxTemplates[template];
      }

      // track the the summary pane event
      gtag('event', 'axTableList', {
        'event_category': 'NoDataPane',
        'event_label': 'table: ' + (typeof(axTbl) != 'undefined' ? axTbl.element.attr('id') : 'unspecified_table') + ', datasource: ' + datasource
      });

      var html = Handlebars.compile(template)(datasource);

      var html_o = $(html);
      var exist_o = this.element.find('.' + html_o.attr('class').replace(' ', '.'));
      // skip empty pane redrawing to avoid blinking
      if (exist_o.length && html_o.text() == exist_o.text()) { return; }

      var container = get_axtable_content_container(self.element);

      var pane;
      if (config.noContainer) {
        pane = html;
      } else {
        pane = $("<div>").addClass('list-empty list-no-data')
						.html(html);
      }

      container.parent().after(pane);
    },

    addEmptyFilterPane : function(config){
      var self = this, axTbl = this.options.axtable, template = config.template, datasource = config.data;

      // Check to see if the template we need is present in our cache
      if (!window.cachedAxTemplates[template]) {
        // Miss
        if (!self.fetchingEmptyFilterPane) {
          // Set semaphor to keep from refetching and re-appending same pane.
          // Seems ugly. Would like a better way.
          self.fetchingEmptyFilterPane = true;
          $.get("/template/" + template, function(tmplt){
            // Save in cache for next time.
            window.cachedAxTemplates[template] = tmplt;
            self.fetchingEmptyFilterPane = false;
            self.addEmptyFilterPane(config);
          });
        }
        return;
      } else {
        template = window.cachedAxTemplates[template];
      }

      // track the the summary pane event
      gtag('event', 'axTableList', {
        'event_category': 'EmptyFilterPane',
        'event_label': 'table: ' + (typeof(axTbl) != 'undefined' ? axTbl.element.attr('id') : 'unspecified_table') + ', datasource: ' + datasource
      });
      var html = Handlebars.compile(template)();
      var pane = $("<div>").addClass('list-empty')
					.html(html);

      pane.find('.clear-filter').on('click', function(){
        gtag('event', 'axTableList', {
          'event_category': 'ResetFilter',
          'event_label': 'table: ' + (typeof(axTbl) != 'undefined' ? axTbl.element.attr('id') : 'unspecified_table') + ', datasource: ' + datasource
        });
        axTbl._trigger('resetfilter');
      });
      this.element.after(pane);
    },

    addSummaryPane : function(row, template, datasource, reload){
      var self = this,
          settings = self.options;
      // track the the summary pane event
      gtag('event', 'axTableList', {
        'event_category': 'SummaryPane',
        'event_label': 'table: ' + (typeof(this.options.axtable) != 'undefined' ? this.options.axtable.element.attr('id') : 'unspecified_table') + ', datasource: ' + datasource
      });

      var prepareSummaryPaneData = function(data) {
        var html = Handlebars.compile(template)(data);
				var td = $("<td>").attr({
					"colspan": row.children().length
				}).html(html);

        var pane = $("<tr>").addClass('trow list-summary')
						.data("id", row.data("id"))
						.html(td);

        if (reload) {
					row.next('.trow.list-summary').remove();
					pane.insertAfter(row);
					row.addClass('openpane').data('isOpen', true);
				} else {
          row.after(pane);
          pane.hide();
          pane.slideDown(function(){
            window.summaryIsAnim = false;
          });
        }

        if (!('summary_pane' in self.cache)) {
          self.cache.summary_pane = {};
        }

        if (settings.restoreSummaryPanes) {
          self.cache.summary_pane[row.data("id")] = {pane: pane, content: self._getRowContent(row)}; // it's better to use crc32 instead of text but it's yet enough
        }
      }

      var onErrorHandler = function () {
				row.data('isOpen', false);
				row.removeClass('openpane');
				window.summaryIsAnim = false;
				show_alert(_error_label, err_request_failed);
			};

      if (typeof datasource === 'function') {
      	datasource(row.data(), prepareSummaryPaneData, onErrorHandler);
      } else {
        // Fetch data about this summary pane from provided data source, supplying the primary key "id"
        $.ajax({
          type: 'POST',
          url: datasource,
          data: row.data(),
          dataType: "json",
          success: prepareSummaryPaneData,
          error: onErrorHandler
        });
      }

    },

    assign_row_click : function(row){
      var self = this, settings = self.options,
          handler = typeof(settings.summaryHandler) === 'string' ? window[settings.summaryHandler] : settings.summaryHandler;

			var _summaryHandler = (typeof(handler) === 'function') ? handler() : handler;

      if (_summaryHandler && settings.isSummaryCanBeOpened(row)) {
        row.click(function(e){
          // Debounce
          if (window.summaryIsAnim) { return; }
          window.summaryIsAnim = true;

          $(e.target).closest(':ax-axTableList').axTableList('killpopout');
          var row = $(e.target).closest('.trow');

          if ((typeof(row.data('isOpen')) !== 'undefined') && row.data('isOpen')) {
            var summary = row.next('.list-summary');
            summary.slideUp(function(){
              window.summaryIsAnim = false;
              summary.remove();
              row.removeClass("openpane");
            });

            row.data('isOpen', false);
            delete self.cache.summary_pane[row.data('id')];
            e.stopPropagation();
            return;
          }
          row.data('isOpen', true);
          row.addClass('openpane');

          // Check to see if the template we need is present in our cache
          if (!window.cachedAxTemplates[_summaryHandler.template]) {
            // Miss
            $.get("/template/" + _summaryHandler.template, function(template){
              // Save in cache for next time.
              window.cachedAxTemplates[_summaryHandler.template] = template;

              self.addSummaryPane(row, template, _summaryHandler.data);
            });
          } else {
            // Hit
            self.addSummaryPane(row, window.cachedAxTemplates[_summaryHandler.template], _summaryHandler.data);
          }

          e.stopPropagation();
        });
      }
    },

    /*
     * Build the table column headers, insert titles, and assign click handlers. Build action column if indicated
     */
    _buildColumnHeaders : function(data){
      var self = this, settings = self.options, columns = $("<tr>"), fillCol = false, column;

      columns.addClass('trow headers-container');

      // If multiSelect enabled, then add the checkbox to the header
      if (settings.multiSelect) {
          column = $("<th>").addClass('heading selectcell');
          var columnInner = $('<span>' + _axtable_list_select + '</span>');
          column.html(columnInner);
          columns.append(column);
      }

      for (var i=0; i < data.columns.length; i++) {
        var curCol = data.columns[i];
        var addedClass = (((typeof(curCol.cssClass) != 'undefined') && (curCol.cssClass.length > 0))
						? curCol.cssClass
						: "cell")
        column = $("<th>").addClass("heading multiline " + addedClass + (curCol.sortable ? '' : ' no_sort'));
        var innerData = $('<span>')
						.addClass('heading-text')
						.html(curCol.label);

        if (curCol.tip) {
					innerData.attr('data-axtooltip', curCol.tip);
				}

				var innerDataContainer = $('<div>').addClass('heading-content')
						.append(innerData);

        if ((settings.sorting) && curCol.sortable) {
					innerDataContainer.append('<span class="ax-interaction"></span>');
        }

				column.html(innerDataContainer);

        if (curCol.sortby){
          column.data({ sortby: curCol.sortby });
        }
        if (curCol.fillWidth){
          //Save for later so that we can auto-adjust after the entire header built.
          fillCol = column;
        }

        columns.append(column);
      }

      if (settings.actionCol) {
        column = $("<th>").addClass('heading action_cell');
        if (settings.multiSelect) {
          column.addClass('multiselect')
							.html('<div class="caret-down-dark"></div>');
        }

        columns.append(column);
      }

      var header = $("<thead>").addClass('axtable-header-container')
					.html(columns);
      this.element.prepend(header);

      // have to set the width of the action col only after the other columns have been added to the DOM.
      if (fillCol) {
        var ac_width = 0, col_width = 0, delta = 0, sel = '.heading:last';
        this.element.find('.heading').each(function(){
          ac_width += $(this).outerWidth();

          //For backwards compatibility, retain this logic so that the col_width is the last column
          col_width = $(this).width();
        });

				col_width = $(fillCol).width();

        /*
         * If it's the actionCol, then we want the actionCol to be the difference between container and total columns width.
         * If we're just expanding the last column, then we want to add the difference to the last column
         *
         * Save onto the settings so that it can be used later in the cell construction from the data
         */
        delta = this.element.innerWidth() - ac_width;
        settings.fillCol_width = col_width + delta;
				fillCol.css('width', settings.fillCol_width + 'px');
      }

      // Provide an ability to turn off the column sorting
      if (settings.sorting) {
        this._assign_header_click(columns);
      }
    },

    clear : function(){
      // TODO - MAKE PART OF CLEAR CONTENT METHOD. NEED TO KNOW WHY OFFSET WAS RESET, SEARCH OR SORT.
      var self = this, settings = self.options;
      this.element.find('.trow:eq(0)').show();
      this.element.find(".trow:gt(0)").remove();
      this.element.find(".list-summary").remove();
      this.element.siblings(".list-empty").remove();
      this.element.siblings(".tabempty").remove();

      if (settings.mutableColumnSet) {
        this.element.find('.headers-container').remove();
      }

      self.isDirty = false;
    },

    fetchdata : function(deferred){
      /*
       * include in the data for the search, any table level settings, such as requesting an updated title
       *
       * include the search data
       *
       * create deferred object to re-register the smartscroll, and toggle need to fetch the title
       *
       * pass data, and deferred to activeView's fetchData method
       *
       */

      // If this is our first time fetching, fetch  the initial amount.
      var self = this, settings = self.options,
        getData = { "inc_title" : self.fetchTitle },
        fetchnum = settings.fetchAmount, fetchHeaders = false;

      if (!self.initialized) {
        fetchnum = settings.initialFetchAmount;
        fetchHeaders = true;
      } else if (settings.mutableColumnSet && settings.fetchOffset == 0) {
        fetchHeaders = true;
      }

      getData.offset = settings.fetchOffset;
      getData.amount = fetchnum;
      getData.sort_col = settings.sortCol;
      getData.sort_dir = settings.sortDir;
      getData.inc_headers = fetchHeaders;

      if (settings.sorting) {
        // store the sorting options on serverside in session at {axtable}_sort id
        // can't use .attr('id') cause to using one container for different tables in inventory
        getData.axtable = settings.dataLocation;
      }

      // TODO - REFACTOR AND MOVE INTO SUPERCLASS THAT BOTH VIEWS INHERIT FROM
      if (self.searchData) {
        for (var prop in self.searchData) {
          var curVal = self.searchData[prop];
          if (((typeof(curVal) == 'string') && (curVal !== '')) || (Array.isArray(curVal) && (curVal.length > 0))) {
            getData.search = self.searchData;
            break;
          }
        }
      }
      if (self.options.preventiveSearchData) {
        getData.preventiveFilter = self.options.preventiveSearchData;
      }

      // do we have a server-side location?
      if (!settings.dataLocation) {
        // do we have a dataProvider?
        if (typeof(settings.dataProvider) == 'function') {
          settings.dataProvider(function(data) {
						if (data && data.columns && data.data) {
							self._processData(data, getData, deferred);
						}
					}, getData);
        }
        return;
      }

      // Are we already processing a request?
      if (self.fetchXHR) {
        self.fetchXHR.abort();
      }

      //Save the jqXHR object so that we if we requery, then we can abort anything in process.
      self.fetchXHR = $.ajax({
        url: settings.dataLocation,
        dataType: 'json',
        data: getData,
        type: 'POST',
        error: function(jqXHR, textStatus, errorThrown){
          self.fetchXHR = false;
        },
        success: function(data, jqXHR, textStatus){
          //We have the data, display it.
          self.fetchXHR = false;
          self._processData(data, getData, deferred);
        }
      });
    },

    _processData: function(data, getData, deferred) {
      var self = this, settings = self.options;
			var axtable = settings.axtable;

      if (typeof(deferred) != 'object') {
        deferred = $.Deferred();
      }

      deferred.done(function(getData, data){
        if (data && (data.data.length != getData.amount) && (getData.offset > 0 || getData.amount > settings.initialFetchAmount)) {
          // Display "That's all folks!" only if the data exceeds what fits on the page
          if (self.element.find(".trow.end-data").length == 0) {
            var end = $('<tr class="trow end-data"></tr>');
            var endTd = $('<td>' + _axtable_list_end + '</td>');
            endTd.attr('colspan', self.element[0].rows[0].cells.length);
						end.append(endTd);
            self.element.append(end);
          }
        } else {
          //Intentionally blank. Data either exceeds the page length completely, or is less than a complete page.
        }
      });

      // This is our first time fetching data, let's render the columns.
      if (!self.initialized) {
        self._buildColumnHeaders(data);
        self.initialized = true;
      } else if (data.is_failed) {
        $(axtable.activeView.element).trigger('autorefresh.axTable.' + axtable.element.attr('id'));
        return;
      } else if (getData.offset == 0) {
        self.clear();
        if (settings.mutableColumnSet) {
          self._buildColumnHeaders(data);
        }
      }

      // restore previously saved sort options
      if (self.options.sorting && data.sort) {
        self.options.sortCol = data.sort.sort_col;
        self.options.sortDir = data.sort.sort_dir;

        // set sorting arrow
        var heading = self.element.find('.trow .heading').not('.selectcell,.action_cell');
        $('.ax-interaction', heading).removeClass('arrow-asc arrow-desc');
        heading.eq( data.sort.sort_col ).find('.ax-interaction').addClass('arrow-' + data.sort.sort_dir);
      }

      var container = get_axtable_content_container(self.element);

      // Let's render the data.
      var trow;
      $.each(data.data, function(index, value){
        var rowAttr = this.rowAttr;
        trow = $("<tr>").addClass('trow');

        for(var attr in rowAttr){
          var attrValue = rowAttr[attr],
              isSerialized = (typeof attrValue === 'string') && ('{['.indexOf(attrValue[0]) != -1);
          trow.attr('data-' + attr, attrValue);

          if (!isSerialized) {
            // In case we have non-serialized object
            // we need to store it directly in jQuery.data
            // to save the real type of it's value.
            // trow.attr('data-test', '4e36');
            // typeof trow.attr('data-test') === 'string';
            // trow.attr('data-test') === '4e36';
            // typeof trow.data('test') === 'number';
            // trow.data('test') === 4e+36;
            trow.data(attr, rowAttr[attr]);
          }
        }
        // Assign the action row click handling
        if (settings.actionRow) {
          trow.on('click', { self: self, rowData: rowData, rowAttr: rowAttr }, settings.actionClickHandler);
        }
        var cell;
        // Add the select column if is enabled
        if (settings.multiSelect) {
          cell = $("<td>");
          var checkbox = $('<input type="checkbox" />');
          // restore selection
          if (self.cache.multiSelect) {
            var matchedCachedIds = self.cache.multiSelect.filter(function(val) {
              return val == trow.attr('data-id');
            });
            if (matchedCachedIds.length) {
              checkbox.prop('checked', true);
            }
          }
          if (settings.readonly) {
            checkbox.prop('disabled', true);
          }
          // persist multiSelect state
          checkbox.on('change', function(e) {
            self._persistMultiSelect();
          });

          var checkboxWCLStyle = $('<div class="checkbox-wcl-style"></div>');
          // simulate a click on the checkbox
          checkboxWCLStyle.on("click", function () {
            checkbox.click();
          });

          cell
            .addClass("selectcell")
            .append(checkbox)
            .on("click", function (e) {
              e.stopPropagation(); /* don't trigger the summary pane row handling */
            });
          cell.append(checkboxWCLStyle);
          trow.append(cell);
        }

        var cssClass, columnindex = 0, rowData = this.rowData, cellA = null, fillCell = false;
        $.each(rowData, function(index, datavals){
					cell = $("<td>");
					cssClass = (((typeof(data.columns[columnindex].cssClass) != 'undefined') && (data.columns[columnindex].cssClass.length > 0)) ? data.columns[columnindex].cssClass : "cell");

          // Allow complex data types instead of just plain text
					if ((datavals != null) && (typeof(datavals) == "object") && (typeof(datavals.type) != "undefined")) {
            if (datavals.type == "image") {
              datavals = $("<img>").attr('alt', '').attr('src', datavals.src);
            } else if (datavals.type == "tooltip") {
              var isTooltip = true;
              var elemType = datavals.tooltipTrunc ? "<div>" : "<span>";
              datavals = $(elemType)
									.addClass(cssClass)
									.attr("data-axtooltip-title", datavals.tooltipTitle)
									.attr("data-axtooltip", datavals.tooltipContent)
									.attr("data-axtooltip-trunc", datavals.tooltipTrunc)
									.html(datavals.text);
            }
          }

          // Is this column the default details click drill down for the primary entity?
          // TODO - attach the cell click handlers to an href that is around in the cell content, rather than against the div that is the cell.
          if ((typeof(data.columns[columnindex].details) != 'undefined') && (data.columns[columnindex].details)) {
            cssClass += ' actionable';
            cellA = $('<a>').attr("href", "javascript:void(0)");

            //Assign the event handler here?
            if (settings.detailsHandler) {
              if (typeof(settings.detailsHandler) == 'function') {
                cellA.on('click', settings.detailsHandler);
              } else {
                //If the handler function name is passed in, rather than the function var reference
                cellA.on('click', window[settings.detailsHandler]);
              }
            } else if (settings.detailsPath) {
              cellA.on('click', { detailsPath : settings.detailsPath }, axtable_details_click);
            }
            //Rewrap block-level tooltip around link
            if(isTooltip) {
              cellA.html($(datavals).html());
              datavals = $(datavals).html(cellA);
            } else {
              datavals = cellA.html(datavals);
            }
          } else {
            // Is there an assigned click handler, for example to drill down on a secondary entity?
            if ((typeof(data.columns[columnindex].click) != 'undefined')) {
              cssClass += ' actionable';
              cellA = $('<a>').attr("href", "javascript:void(0)")
									.on('click', window[data.columns[columnindex].click]);
              datavals = cellA.html(datavals);
            }
          }

          cell.addClass(cssClass);

          //apply the auto expanding to the fill column
          if (data.columns[columnindex].fillWidth){
            fillCell = cell;
            cell.attr({'style' : 'width: ' + settings.fillCol_width + 'px;'} );
          }
          if (data.columns[columnindex].cellTip){
            cell.attr('data-axtooltip', value.rowData[index]).attr('data-axtooltip-trunc', true);
          }

          cell.html(datavals);
          trow.append(cell);
          columnindex++;
        });

        // Assign the action cell click handling
        if (settings.actionCol) {
          var hideForReplibitVersion = (rowData[1] === 'Replibit') && (settings.dataLocation === '/version/version_list');
          if (((rowAttr.version_id === undefined) || (rowAttr.version_id > 0)) && !hideForReplibitVersion) {
            cell = $("<td>").addClass('action_cell')
								.html('<span class="ax-interaction caret-down"></span>')
								.on('click', { self: self, rowData: rowData, rowAttr: rowAttr }, settings.actionClickHandler);
            trow.append(cell);
          }
        }

        container.append(trow);

        self.assign_row_click(trow);
      });

      settings.fetchOffset += getData.amount;

      // FIXME - EVENT FOR DATA RETRIEVED - USE TO BUILD TITLE OR PREFORM DATA PROCESSING. INDICATOR FOR END OF DATA REACHED!
      if (typeof(deferred) == 'object') {
        deferred.resolve(getData, data);
      }

      if (typeof settings.onFetchHandler == 'function') {
        settings.onFetchHandler(data);
      }

      $(self.element).trigger('datafetched.axTable', data);

      if (settings.sorting && settings.clientSideSorting) {
        self._sort();
      } else {
        self._restoreSummaryPane();
        self._restoreActivePopout();
      }

      var $axtable_view = $(self).find('.axtableview .mCustomScrollbar');
      if ($axtable_view) {
        $axtable_view.mCustomScrollbar("update");
      }
    },

    reloadSummaryPaneData : function($row) {
      var settings = this.options,
          handler = typeof(settings.summaryHandler) === 'string' ? window[settings.summaryHandler] : settings.summaryHandler;

			var _summaryHandler = (typeof(handler) === 'function') ? handler() : handler;

      // reload summary pane
      this.addSummaryPane($row, window.cachedAxTemplates[_summaryHandler.template], _summaryHandler.data, true);
    },

    refreshSummaryPane : function(rowId) {
      var $row = $(this.element).find('.trow[data-id="'+rowId+'"]');
      this.reloadSummaryPaneData($row);
    },

    _restoreSummaryPane : function() {
      var self = this;
      var rows = $(self.element).find('.trow:gt(0)').get();

      if (!('summary_pane' in self.cache)) { return; }

      $.each(rows, function() {
        var $this = $(this);
        var row_id = $this.data('id');
        if (row_id in self.cache.summary_pane) {
          // don't refresh the pane if row text wasn't changed
          if (self.options.axtable.options.autoRefresh && self._getRowContent($this) != self.cache.summary_pane[row_id].content) {
            self.reloadSummaryPaneData($this);
          }
          $(self.cache.summary_pane[row_id].pane).insertAfter($this).data({id: row_id});
          $this.addClass('openpane').data('isOpen', true);
        }
      });
    },

    _restoreActivePopout : function() {
      var self = this;
      if (self.cache.activePopoutId){
        var rows = $(self.element).find('.trow:gt(0)');
        $.each(rows, function() {
          var $this = $(this);
          var row_id = $this.data('id');
          if (row_id == self.cache.activePopoutId) {
            var popout = $this.find(".caret-down");
            if(popout){
              popout.click();
            }
          }
        });
      }
    },

    _getRowContent: function($row) {
      var self = this;
      var collector_func = self.options.rowContentCollector;
      return (typeof collector_func == 'function') ? collector_func($row) : $row.text();
    },

    _persistMultiSelect: function() {
      var self = this;

      self.cache.multiSelect = [];
      $(self.element).find('.selectcell :checkbox:checked:not(:disabled)').each(function() {
        self.cache.multiSelect.push($(this).parents('.trow').data('id'));
      });
    },

    /**
     * Default action cell click handler
     */
    actionCellClick : function(e){
      var self = e.data.self,
					$this = $(this),
					settings = self.options,
					trow = $this.closest('.trow'),
					popoutTemplate = $("#" + settings.popoutTemplate),
					popout = popoutTemplate.clone( true ),
					togglePopout = self.is_popout_active() && trow.is('.activerow');

      self.killpopout();

      if (togglePopout) { e.stopPropagation(); return; }

      popout.attr('id', '').removeClass('popout-template').addClass('popout');
			$this.append(popout);

      var ytarget = trow.position().top + trow.outerHeight();

      popout.css({ 'top' : ytarget, 'right' : 0 });
      popout.show();

      trow.addClass("activerow");

      e.stopPropagation();

      popout.find('.popoutitem').each(function(){
        clkHandler = $(this).data('clickHandler');
        if (typeof(clkHandler) == 'function') {
          $(this).on('click', clkHandler);
        }
      });
      self.cache.activePopoutId = trow.attr('data-id');
    },

    multiselectCellClick : function(e){
      var self = e.data.self,
					$this = $(this),
        settings = self.options,
        trow = $this.closest('.trow'),
        multiselectPopoutTemplate = $("#" + settings.multiselectPopoutTemplate),
        popout = multiselectPopoutTemplate.clone( true ),
        togglePopout = self.is_popout_active() && trow.is('.activerow');

      self.killpopout();

      if (togglePopout) { e.stopPropagation(); return; }

      popout.attr('id', '').removeClass('popout-template').addClass('popout');
			$this.append(popout);

      var ytarget = trow.outerHeight();

      popout.css({ 'top' : ytarget, 'right' : 0 });
      popout.show();

      trow.addClass("activerow");

      e.stopPropagation();

      popout.find('.popoutitem').each(function(){
        clkHandler = $(this).data('clickHandler');
        if (typeof(clkHandler) == 'function') {
          $(this).on('click', clkHandler);
        }
      });
    },

    /**
     * Default notify handler
     */
    notify : function(event) {
      event.data.reset();
    },

    /**
     * Ideally, this would refresh all data, but right now it just refreshes the open summary panes.
     * And it does this by closing and re-opening them. Good enough for Protect Flow first release.
     * But hack-y & the animation isn't ideal
     */
    refresh : function(){
      $.fx.off = true;
      this.element.find('.trow').each(function(){
        var row = $(this);
        if ((typeof(row.data('isOpen')) !== 'undefined') && row.data('isOpen')) {
          // put it up
          var summary = row.next('.list-summary');
          summary.slideUp(function(){
            window.summaryIsAnim = false;
            summary.remove();
            row.removeClass("openpane");
            row.data('isOpen', false);
            // put it down
            row.click();
          });
        }
      });
      $.fx.off = false;
    }
  });

  $.widget("ax.axTable", {
    options: {
      hasTitle            : false,
      titleIconClass      : false,
      viewMoreLink        : false,
      fetchOnScroll       : false,
      defaultView         : 'axTableList',
      autoRefresh         : 0,                // auto refresh is disabled by default. Pass value > 499 to enable
      fetchOnInit         : true,             // automatically fetch data when axTable created, may be used to postpone data fetching
      type                : 'generic',
      handler             : false,
      events              : true,
      views               : {
        axTableList       : {}
      }
    },

    initialized  : false,
    fetchTitle   : false,
    activeView   : false,
    views        : {},
    searchData   : false,
    fetchTimeout : null,

    destroy : function() {
      var event = '.axTable.' + this.element.attr('id');
      $(this.activeView.element).off(event);
      $(this.element).off(event);
      $.Widget.prototype.destroy.call(this);
    },

    _create : function(){
      var self = this,
        viewEl,
        settings = self.options,
        prvSearch = $.cookie('searchData-' + this.element.attr('id')),
        prvView   = $.cookie('selView-' + this.element.attr('id'));
      if (settings.events) {
        if (typeof(settings.events) == 'boolean') {
          // Put the default events into the settings.events format.
          settings.events = ['save', 'delete'];
          for (var i=0; i < settings.events.length; i++) {
            settings.events[i] = settings.events[i] + '.' + this.options.type; + '.axTable.' + this.element.attr('id');
          }
        }

        // Scope the registered events to this table, and unbind and bind
        for (var i = 0; i < settings.events.length; i++) {
          var ev = settings.events[i] + '.axTable.' + this.element.attr('id');
          $(document).off(ev).on(ev, self, self.notify);
        }
      }

      if (prvView != null) {
        settings.defaultView = prvView;
      }

      if (prvSearch != null) {
        this.searchData = JSON.parse(prvSearch);
      }
      /*
       * Need to manually copy any over-rides on the list view in the listView object.
       * Store the view builders on a private variable of some kind, and then copy the settings over using $.extend
       */
      for (var tableView in settings.views) {
        if (tableView == 'axTableIndexCard') {
          viewEl = $("<div>");
          viewEl.addClass('axtableview ' + tableView);
        } else {
          viewEl = $("<table>");
          viewEl.addClass('table table-sm table-hover axtableview ' + tableView);
        }

        // add an axTable back pointer object reference to child views
        settings.views[tableView].axtable = self;

        var theViewWidget = viewEl[tableView](settings.views[tableView]), theViewObj = theViewWidget.data('ax-' +tableView);

        if (this.searchData) {
          theViewObj.searchData = this.searchData;
        }

        // Pass along the indication of whether to fetch and rebuild the title
        theViewObj.fetchTitle =  settings.hasTitle;

        /*
         * Save the actual widget object, the code for the widget, back to the array so can call method directly
         * Rather than using the jQueryUI widget interface
         */
        settings.views[tableView] = theViewObj;
        if (tableView == settings.defaultView) {
          this.activeView = theViewObj;
          this.activeViewName = tableView;
        }
        var $axtableContainer = $('<div class="axtable-container" data-view="' + tableView + '">');
        if (tableView === 'axTableList') {
					$axtableContainer.addClass('table-responsive');
        }

				$axtableContainer.html(viewEl);
				this.element.append($axtableContainer);
      }

      // For CSS Scoping
      this.element.addClass("axtable");

      // re-bind axtable scroll event on create
      var eventType = 'smartscroll.' + self.activeViewName + '.' + self.element.attr('id');
      $(window).off(eventType).on(eventType, { self: self }, self._infiscroll);

      var refreshEvent = 'autorefresh.axTable.' + self.element.attr('id');
      $(viewEl).off(refreshEvent).on(refreshEvent, { self: self }, self._autoRefresh);

      if (settings.fetchOnInit) {
        // Looks like a data location has been specified. We're using remote data, let's load it.
        this._fetchdata();
      }
      this._trigger('createcomplete');
    },

    _buildTitle : function(data){
      // This is old school, but more concise to add the entire structure
      var self = this, settings = self.options,
        viewNames = Object.keys(settings.views), title;

      var $container = self.element.find('.title-container');

      if ($container.length > 0) {
        $container.find('.title').html(data.title);
        $container.find('.helpicon').remove();
      } else {
        $container = $('<div class="title-container">');
        if (settings.titleIconCSS){
          $container.append($('<div class="' + settings.titleIconCSS + '"></div>'));
        }
        if (settings.iconedTitle) {
					$container.append($('<h2 class="font-weight-bold mb-3"><span class="mr-1 float-left ' + settings.iconedTitle +'"></span><b class="title">' + escapeHTML(data.title) + '</b></h2>'));
				} else {
					$container.append($('<div class="title">' + escapeHTML(data.title) + '</div>'));
				}

        if (settings.viewMoreLink){
          $container.append($(settings.viewMoreLink));
        }

        // Iterate all the content renderers and assign click handlers
        if (viewNames.length > 1) {
          for (var i = viewNames.length - 1; i >= 0; i--) {
            var tableView = viewNames[i], icon = $("<div>");

            icon.addClass(settings.views[tableView].iconCssClass)
								.addClass(tableView == settings.defaultView ? 'active' : 'default')
								.data('viewName', tableView)
								.on('click', function (e) {
									self.toggleView($(e.target).data('viewName'));
								});
            $container.append(icon);
          }
        }
        $container.append($('<div class="clear_both"></div>'));

        if (this.element.find('.axfilter').length) {
          this.element.find('.axfilter').prepend($container);
        } else {
          this.element.children(':first-child').before($container);
        }
      }

      if (data.title_hint) {
        var $hint = $('<span class="helpicon"></span>').attr('data-axTooltip', data.title_hint);
        $hint.insertAfter($container.find('.title'));
      }
    },

    _autoRefresh : function(e) {
      var self = e.data.self, settings = self.options, view = self.activeView;
      var autoRefresh = parseInt(settings.autoRefresh);

      setTimeout(function() {
        if (autoRefresh < 500) { return; }
        if (view.options.preventDataRefresh()) {
          $(view.element).trigger('autorefresh.axTable.' + self.element.attr('id'));
          return;
        }

        if ($(view.element).is(':visible')) {
          self.reset(); // refresh axTable if it's visible
        } else {
          // trigger auto refresh, without data reload, don't spam the server
          $(view.element).trigger('autorefresh.axTable.' + self.element.attr('id'));
        }
      }, autoRefresh);
    },

    /*
     * Toggle-icon click handler, and toggle view
     */
    toggleView : function(newViewName){
      // Is newView the currently activeView?
      if (newViewName == this.activeView.widgetName) {
        return;
      }

      var newView = this.options.views[newViewName], oldView = this.activeView;

      // Preserve the new view for re-rendering the list later
      $.cookie('selView-' + this.element.attr('id'), newViewName, { expires: 7, secure: true });

      // In title, make the active toggle-icon default, and make the appropriate icon active
      this.element.find('.title-container .toggle-icon.active').removeClass('active').addClass('default');
      this.element.find('.title-container .toggle-icon.' + newView.widgetName).removeClass('default').addClass('active');

      // set this.activeView to the current active view
      this.activeView = newView;
      this.activeViewName = newView.widgetName;

      // if is dirty, then clear the new active view and make it fetch data
      if (newView.options.fetchOffset == 0) {
        this._fetchdata();
      }

      this.element.find('.axtable-container[data-view="' + oldView.widgetName + '"]').hide();
      this.element.find('.axtable-container[data-view="' + newView.widgetName + '"]').show();
    },

    _initialize : function(data){
      var settings = this.options;

      if (settings.hasTitle){
        this._buildTitle(data);
      }

      // FIXME - This should probably occur within a Deferred Object
      this.initialized = true;
      this.fetchTitle = false;
    },

    _fetchdata : function(){
      /*
       * include in the data for the search, any table level settings, such as requesting an updated title;
       * include the search data;
       * create deferred object to re-register the smartscroll, and toggle need to fetch the title;
       * pass data, and deferred to activeView's fetchData method;
       */

      // If this is our first time fetching, fetch  the initial amount.
      var self = this, settings = self.options, deferred = $.Deferred(),
        view = self.activeView;

      // cancel any remaining fetchTimeout
      if (this.fetchTimeout) {
        clearTimeout(this.fetchTimeout);
        this.fetchTimeout = null;
      }

      deferred.done(function(getData, data){
        if ((settings.hasTitle) && (typeof(data.title) != 'undefined')) {
          self._buildTitle(data);
        }

        var eventType = 'smartscroll.' + self.activeViewName + '.' + self.element.attr('id');
        // unbind scroll event before data fetching
        $(window).off(eventType);

        if (data && (data.data.length == getData.amount)) {
          // Only set the scroll event if there appears to be more data to be fetched.
          if (settings.fetchOnScroll) {
            $(window).on(eventType, { self : self }, self._infiscroll);
            // Load the next portion of entities in case the current amount
            // is not enough to display a vertical scrollbar for infinity scrolling
            if ($(window).height() === $(document).height()) {
              self._fetchdata();
            }
          }
        } else if (getData.search && (data.data.length == 0) && (getData.offset == 0)) {
          // clear pane to avoid duplicated view
          view.clear();
          // User has searched and there are no results that fit the filter criteria.
          view.addEmptyFilterPane(view.options.emptySearchHandler);
        } else if (!getData.search && (data.data.length == 0) && (getData.offset == 0)) {
          // clear pane to avoid duplicated view
          view.clear();
          // User has no data to display
          if (typeof(view.options.noDataHandler) == 'function') {
            view.addNoDataPane(view.options.noDataHandler(), data.params);
          } else {
            view.addNoDataPane(view.options.noDataHandler, data.params);
          }
        }

        if (parseInt(settings.autoRefresh) > 499) {
          $(view.element).trigger('autorefresh.axTable.' + self.element.attr('id'));
        }
      });
      view.fetchdata(deferred);
    },

    _infiscroll : function(e){
      if(( $(window).scrollTop() >= $(document).height() - $(window).height() - 300)
          && ! $('.ui-widget-overlay, .flow-backdrop').filter(':visible').length ){
        // fetchOnScroll only when no overlays
        var axtable = e.data.self;
        if(axtable.options.autoRefresh > 0){
          axtable.activeView.options.fetchAmount += axtable.activeView.options.fetchOffset;
          axtable.activeView.options.fetchOffset = 0;
        }
        axtable._fetchdata();
      }
    },

    /*
     * This doesn't really do a complete reset. The search and columns are retained.
     */
    reset : function(){
      this.activeView.options.fetchOffset = 0;
      this.fetchTitle = true;
      this._fetchdata();
    },

    /*
     * Delegate the selected call to the activeView, if the call exists. If not, return
     * an empty collection.
     */
    selected : function(){
      if (typeof(this.activeView.selected) != 'function') {
        console.log("selected function doesn't exist on activeView");
        return new Array();
      }
      return this.activeView.selected();
    },

    search : function(val){
      if (typeof(val) == 'undefined') {
        return this.searchData;
      }

      gtag('event', 'axTable', {
        'event_category': 'Search',
        'event_label': this.element.attr('id')
      });

      this.searchData = val;

      $.cookie('searchData-' + this.element.attr('id'), JSON.stringify(val), { expires: 7, secure: true });

      // Delay call because user might make another call immediately after
      if (this.fetchTimeout) {
        clearTimeout(this.fetchTimeout);
      }

      var self = this, x = function () {
        // set the isDirty flag on all the other table views
        var keys = Object.keys(self.options.views);
        if (keys.length > 0) {
          var curView;

          for (var i = 0; i < keys.length; i++) {
            curView = self.options.views[keys[i]];
            curView.isDirty = true;
            curView.searchData = val;
            curView.options.fetchOffset = 0;
            curView.clear();
          }
          self._fetchdata();
        }
      };
      this.fetchTimeout = setTimeout(x, 200);
    },

    /*
     * Notify handler
     */
    notify: function(e) {
      if (typeof e.data.options.handler === "function") {
        e.data.options.handler();
      } else {
        // TODO - delegate to an appopriate function in the activeView so that the view can update intelligently
        e.data.reset();
      }
    },

    refresh: function(){
      if (this.activeView.refresh){
        this.activeView.refresh();
      }
    }
  });

  window.cachedAxTemplates = {};

  /*
   * smartscroll: debounced scroll event for jQuery *
   * https://github.com/lukeshumard/smartscroll
   * Based on smartresize by @louis_remi: https://github.com/lrbabe/jquery.smartresize.js *
   * Copyright 2011 Louis-Remi & Luke Shumard * Licensed under the MIT license. *
   */

  var event = $.event, scrollTimeout;

  event.special.smartscroll = {
    setup: function (){
      $(this).on("scroll", event.special.smartscroll.handler);
    },
    teardown: function (){
      $(this).off("scroll", event.special.smartscroll.handler);
    },
    handler: function (event, execAsap){
      // Save the context
      var context = this;

      // set correct event type
      event.type = "smartscroll";

      if (scrollTimeout) { clearTimeout(scrollTimeout); }
      scrollTimeout = setTimeout(function () {
        $('.axtable:visible').each(function() {
          var $axtable = $(this),
              activeViewName = ($axtable.data('ax-axTable') || {}).activeViewName,
              axTableId = $axtable.attr('id');
          if ((!!axTableId) && (!!activeViewName)) {
            $(context).trigger('smartscroll.'+activeViewName+'.'+axTableId);
          }
        });
      }, execAsap === "execAsap" ? 0 : 100);
    }
  };

  $.fn.smartscroll = function (fn) {
    return fn ? this.on("smartscroll", fn) : this.trigger("smartscroll", ["execAsap"]);
  };
})( jQuery );
